module.exports = __webpack_public_path__ + "img/25_35.982dc924.png";